import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { DisposableStore, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { registerTerminalContribution } from '../../../terminal/browser/terminalExtensions.js';
import { TypeAheadAddon } from './terminalTypeAheadAddon.js';
import { TERMINAL_CONFIG_SECTION } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminal';

var TerminalTypeAheadContribution_1;
let TerminalTypeAheadContribution = class TerminalTypeAheadContribution extends DisposableStore {
    static { TerminalTypeAheadContribution_1 = this; }
    static { this.ID = 'terminal.typeAhead'; }
    static get(instance) {
        return instance.getContribution(TerminalTypeAheadContribution_1.ID);
    }
    constructor(instance, _processManager, widgetManager, _configurationService, _instantiationService) {
        super();
        this._processManager = _processManager;
        this._configurationService = _configurationService;
        this._instantiationService = _instantiationService;
        this.add(toDisposable(() => this._addon?.dispose()));
    }
    xtermReady(xterm) {
        this._loadTypeAheadAddon(xterm.raw);
        this.add(this._configurationService.onDidChangeConfiguration(e => {
            if (e.affectsConfiguration("terminal.integrated.localEchoEnabled" )) {
                this._loadTypeAheadAddon(xterm.raw);
            }
        }));
        this.add(this._processManager.onProcessReady(() => {
            this._addon?.reset();
        }));
    }
    _loadTypeAheadAddon(xterm) {
        const enabled = this._configurationService.getValue(TERMINAL_CONFIG_SECTION).localEchoEnabled;
        const isRemote = !!this._processManager.remoteAuthority;
        if (enabled === 'off' || enabled === 'auto' && !isRemote) {
            this._addon?.dispose();
            this._addon = undefined;
            return;
        }
        if (this._addon) {
            return;
        }
        if (enabled === 'on' || (enabled === 'auto' && isRemote)) {
            this._addon = this._instantiationService.createInstance(TypeAheadAddon, this._processManager);
            xterm.loadAddon(this._addon);
        }
    }
};
TerminalTypeAheadContribution = TerminalTypeAheadContribution_1 = ( __decorate([
    ( __param(3, IConfigurationService)),
    ( __param(4, IInstantiationService))
], TerminalTypeAheadContribution));
registerTerminalContribution(TerminalTypeAheadContribution.ID, TerminalTypeAheadContribution);
